"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollShadows = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const utils_1 = require("@react-aria/utils");
const react_1 = require("react");
const src_1 = require("..");
function ScrollShadows(props) {
    const { children, xss, horizontal = false, bgColor = src_1.Palette.White } = props;
    const { height = "auto", width = "auto" } = xss !== null && xss !== void 0 ? xss : {};
    const tid = (0, src_1.useTestIds)(props);
    // This is admittedly extremely hacky. It expects the background color to be in the format "rgba(255, 255, 255, 1)".
    // If we ever change how we define our color palette in Beam, then this will break and will need to be fixed.
    if (!bgColor.includes("rgba")) {
        throw new Error("ScrollShadows: bgColor prop must be in the format 'rgba(255, 255, 255, 1)'");
    }
    const [showStartShadow, setShowStartShadow] = (0, react_1.useState)(false);
    const [showEndShadow, setShowEndShadow] = (0, react_1.useState)(false);
    const scrollRef = (0, react_1.useRef)(null);
    // The shadow styles will rarely every change. Memoize them to avoid recomputing them when we don't have to.
    const [startShadowStyles, endShadowStyles] = (0, react_1.useMemo)(() => {
        const transparentBgColor = bgColor.replace(/,1\)$/, ",0)");
        const commonStyles = src_1.Css.absolute.z3.add({ pointerEvents: "none" }).$;
        const startShadowStyles = !horizontal ? src_1.Css.top0.left0.right0.hPx(40).$ : src_1.Css.left0.top0.bottom0.wPx(25).$;
        const endShadowStyles = !horizontal ? src_1.Css.bottom0.left0.right0.hPx(40).$ : src_1.Css.right0.top0.bottom0.wPx(25).$;
        const startGradient = `linear-gradient(${!horizontal ? 180 : 90}deg, ${bgColor} 0%, ${transparentBgColor} 92%);`;
        const endGradient = `linear-gradient(${!horizontal ? 0 : 270}deg, ${bgColor} 0%, ${transparentBgColor} 92%);`;
        return [
            { ...commonStyles, ...startShadowStyles, ...src_1.Css.add("background", startGradient).$ },
            { ...commonStyles, ...endShadowStyles, ...src_1.Css.add("background", endGradient).$ },
        ];
    }, [horizontal, bgColor]);
    const updateScrollProps = (0, react_1.useCallback)((el) => {
        const { scrollTop, scrollHeight, clientHeight, scrollWidth, scrollLeft, clientWidth } = el;
        const start = horizontal ? scrollLeft : scrollTop;
        const end = horizontal ? scrollWidth : scrollHeight;
        const boxSize = horizontal ? clientWidth : clientHeight;
        setShowStartShadow(start > 0);
        setShowEndShadow(start + boxSize < end);
    }, 
    // TODO: validate this eslint-disable. It was automatically ignored as part of https://app.shortcut.com/homebound-team/story/40033/enable-react-hooks-exhaustive-deps-for-react-projects
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Use a ResizeObserver to update the scroll props to determine if the shadows should be shown.
    // This executes on render and subsequent resizes which could be due to content/`children` changes (such as responses from APIs).
    // TODO: validate this eslint-disable. It was automatically ignored as part of https://app.shortcut.com/homebound-team/story/40033/enable-react-hooks-exhaustive-deps-for-react-projects
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onResize = (0, react_1.useCallback)(() => scrollRef.current && updateScrollProps(scrollRef.current), []);
    (0, utils_1.useResizeObserver)({ ref: scrollRef, onResize });
    return ((0, jsx_runtime_1.jsxs)("div", { css: src_1.Css.relative.overflowHidden
            .h(height)
            .w(width)
            .df.fd(!horizontal ? "column" : "row").$, ...tid, children: [showStartShadow && (0, jsx_runtime_1.jsx)("div", { css: startShadowStyles }), showEndShadow && (0, jsx_runtime_1.jsx)("div", { css: endShadowStyles }), (0, jsx_runtime_1.jsx)("div", { css: {
                    ...xss,
                    ...src_1.Css.overflowAuto.fg1.addIn("&::-webkit-scrollbar", { display: "none" }).add("scrollbarWidth", "none").$,
                }, onScroll: (e) => updateScrollProps(e.currentTarget), ref: scrollRef, children: children })] }));
}
exports.ScrollShadows = ScrollShadows;
